/** @format */

import { skipToken } from "@reduxjs/toolkit/dist/query";
import React, { PropsWithChildren, ReactElement } from "react";
import { useAppSelector } from "../app/hooks";
import { useGetUserQuery } from "../app/services/userApi";

export type AuthFlagProps = {
  authGroup: string | string[];
  fallback?: ReactElement;
};

const AuthFlag: React.FC<PropsWithChildren<AuthFlagProps>> = ({
  children,
  authGroup,
  fallback,
}) => {
  const authGroups: string[] = !!Array.isArray(authGroup)
    ? authGroup
    : [authGroup];

  const isAuthenticated =
    useAppSelector((state) => state.auth.userToken?.token) || false;
  const { data: user, isLoading } = useGetUserQuery(
    !!isAuthenticated ? undefined : skipToken,
  );

  return !isLoading && user !== undefined && authGroups.includes(user.role) ? (
    <>{children}</>
  ) : (
    fallback || null
  );
};

export default AuthFlag;
